import type { SVGProps } from "react";
export interface BreadLongIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BreadLongIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BreadLongIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.703 11.58a1.125 1.125 0 0 1 1.312-.741l.112.03 2.884.961.107.043a1.125 1.125 0 0 1-.708 2.122l-.111-.03-2.884-.961-.107-.043a1.126 1.126 0 0 1-.605-1.381M7.588 8.3A1.125 1.125 0 0 1 8.9 7.557l.11.031 3.183 1.06.108.042a1.126 1.126 0 0 1-.71 2.124l-.109-.031-3.183-1.06-.107-.043a1.124 1.124 0 0 1-.604-1.38m3.523-3.069a1.126 1.126 0 0 1 1.313-.742l.111.03 2.84.948a1.124 1.124 0 0 1-.711 2.134l-2.84-.946-.108-.042a1.126 1.126 0 0 1-.605-1.382"
      />
      <path
        fill={color}
        d="M19.11.92c.942-.111 1.92-.03 2.671.487l.208.154c.467.375.802.848.983 1.403.201.617.185 1.257.06 1.856-.243 1.169-.945 2.409-1.775 3.579-1.678 2.363-4.227 4.906-6.09 6.769-1.862 1.862-4.405 4.41-6.768 6.088-1.17.83-2.41 1.533-3.58 1.776-.598.125-1.238.141-1.855-.06-.635-.206-1.16-.615-1.557-1.19-.517-.751-.598-1.73-.488-2.671.114-.974.454-2.089.992-3.278 1.078-2.385 3.014-5.215 5.86-8.061l.535-.523c2.666-2.563 5.292-4.328 7.528-5.338 1.19-.538 2.304-.878 3.277-.992Zm1.396 2.34c-.098-.067-.423-.19-1.133-.107-.678.08-1.564.333-2.613.807-1.963.887-4.38 2.493-6.894 4.909l-.502.495c-2.692 2.692-4.458 5.302-5.404 7.396-.474 1.05-.727 1.935-.807 2.613-.083.71.04 1.035.107 1.133.14.203.274.285.4.326.143.047.366.067.701-.003.703-.146 1.634-.626 2.735-1.407 2.179-1.547 4.581-3.946 6.48-5.845 1.9-1.9 4.299-4.302 5.846-6.48.781-1.102 1.261-2.033 1.407-2.736.07-.335.05-.558.003-.701a.7.7 0 0 0-.195-.296z"
      />
    </svg>
  );
}
